export const PostCallSheetTestIds = {
  DRAWER: 'mobile-post-call.drawer',
  DISPOSITION: 'mobile-post-call.disposition-select',
  NOTE: 'mobile-post-call.note-input',
  SKIP: 'mobile-post-call.skip-button',
  SAVE: 'mobile-post-call.save-button',
};
